import Content from "./Content";

export default class TextContent extends Content {
    constructor(languagePack, contentID, text, balloonType, x, y, label) {
        super(TextContent.NAME, TextContent.TYPE, label, languagePack, contentID);

        this._x;
        this._y;
        this._balloonType;

        this.setX(x);
        this.setY(y);
        this.setBalloonType(balloonType);

        this.setText(text);
    }

    setText(value) {
        if (this.getText() !== value) {
            this.setLanguagePackText(TextContent.TEXT_LABEL, value);
        }
    };

    getText() {
        return this.getLanguagePackText(TextContent.TEXT_LABEL);
    };

    setBalloonType(value) {
        this._balloonType = value;
    };

    getBalloonType() {
        return this._balloonType;
    };

    setX(value) {
        this._x = value;
    };

    getX() {
        return this._x;
    };

    setY(value) {
        this._y = value;
    };

    getY() {
        return this._y;
    };

    convertToObject() {
        return this.getObject(["balloonType", "x", "y"]);
    };

}


TextContent.NAME = "Text";
TextContent.TYPE = "engTextContent";
TextContent.TEXT_LABEL = "text";
